var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":_vm.size,"color":"grey lighten-3"}},[(_vm.avatar)?_c('v-img',{attrs:{"src":_vm.avatar}}):_c('v-img',{attrs:{"src":("https://robohash.org/" + _vm.seed + ".png?size=" + _vm.size + "x" + _vm.size)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }